import { createContext } from 'react';

import { BrandData } from '@src/lib/ssr/types';

export const BrandContext = createContext<BrandData | undefined>(undefined);
export const BrandProvider = BrandContext.Provider;
